import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { CoreRoutingModule } from "./core-routing.module";


import { NavbarComponent } from './navbar/navbar.component';
import { LoaderComponent } from './loader/loader.component';
import { FooterComponent } from './footer/footer.component';
import { MainComponent } from './main/main.component';

import { MessagesModule } from '../messages/messages.module';

import { AppService } from '../../services/app.service';
import { MessageService } from '../../services/message.service';
import { SystemService } from '../../services/system.service';
import { ConfigService } from '../../services/app-config.service';
import { UserService } from '../../services/user.service';
import { AuthGuardService } from '../../services/auth-guard.service';
import { ThemeService } from '../../services/theme.service';
import { MenuService } from '../../services/menu.service';
import { NotificacionesService } from '../../services/notificaciones.service';


@NgModule({
  declarations: [
    NavbarComponent,
    LoaderComponent,
    FooterComponent,
    MainComponent
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    MessagesModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,

  ],
  providers: [
    AppService,
    MessageService,
    SystemService,
    ConfigService,
    UserService,
    AuthGuardService,
    ThemeService,
    MenuService,
    DatePipe,
    NotificacionesService
  ]
})
export class CoreModule { }

